import React, { useState } from 'react';
import ImageUploader from 'react-images-upload';
import { MAX_FILE_SIZE, ALLOWED_IMAGE_EXTENTIONS } from '../../../configs';

import './Uploader.css';

export const Uploader = ({ onDrop, buttonText }) => {
    const [count, setCount] = useState(0);
    const [error, setError] = useState(false);
    return (
        <ImageUploader
            className="Uploader d-flex justify-content-center align-items-center img-thumbnail"
            withIcon={false}
            withLabel={false}
            singleImage={true}
            //withPreview
            maxFileSize={MAX_FILE_SIZE}
            errorClass={`size-error ${error ? 'hide-size-error' : ''}`}
            imgExtension={ALLOWED_IMAGE_EXTENTIONS}
            fileContainerStyle={{ display: 'flex', flexDirection: 'row' }}
            buttonText={buttonText}
            onChange={picture => {
                if (picture && picture.length !== 0 && count < picture.length) {
                    setCount(count + 1);
                    setError(true);
                    onDrop(picture);
                } else {
                    setError(false);
                }
            }}
        />
    );
};
